import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { ErrorLoggerService } from './error-logger.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private readonly injector: Injector) {}

  public handleError(error: Error | HttpErrorResponse): void {
    this.injector.get(ErrorLoggerService).log(error);
  }
}
